import { bigCards } from "@/mocks/homeData";

export default function BigCardFlow() {
  const [lead, ...rest] = bigCards;

  return (
    <section id="features" className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300/70 pb-5">
        <div>
          <span className="font-label text-[11px] tracking-[0.24em] text-secondary-600">FEATURES</span>
          <h3 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            大图特辑
          </h3>
        </div>
        <p className="max-w-md font-body text-sm leading-7 text-foreground-700">
          比速递慢一点，比速递深一点。三篇长文，把散落的线索重新拼成完整的故事。
        </p>
      </div>

      <div className="mt-8">
        <article className="group grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-2">
          <div className="h-[260px] w-full overflow-hidden md:h-[340px] lg:h-full lg:min-h-[380px]">
            <img
              src={lead.image}
              alt="44黑料区深度特辑：选秀节目十年回顾"
              title="44黑料区 深度特辑 最新动态"
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
          </div>
          <div className="flex flex-col justify-center p-6 md:p-8">
            <span className="w-fit rounded-sm bg-primary-100 px-2 py-1 font-label text-[11px] font-medium text-primary-700">
              {lead.label}
            </span>
            <h4 className="mt-4 font-heading text-xl font-black leading-8 text-foreground-950 md:text-2xl md:leading-9">
              {lead.title}
            </h4>
            <p className="mt-4 font-body text-sm leading-7 text-foreground-700">{lead.excerpt}</p>
            <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 font-label text-xs text-secondary-600">
              <span>{lead.author}</span>
              <span className="h-3 w-px bg-background-300" />
              <span>{lead.readTime}</span>
              <span className="h-3 w-px bg-background-300" />
              <span>{lead.views} 阅读</span>
            </div>
            <a
              href="#archive"
              className="mt-6 flex w-fit items-center gap-2 whitespace-nowrap font-label text-sm font-medium text-primary-700 transition-colors duration-200 hover:text-primary-800"
            >
              阅读全文
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </article>

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          {rest.map((card) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="h-[220px] w-full overflow-hidden md:h-[240px]">
                <img
                  src={card.image}
                  alt={`44黑料区特辑：${card.title}`}
                  title={`${card.title} 44黑料区今日黑料`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <span className="w-fit rounded-sm bg-accent-100 px-2 py-1 font-label text-[11px] font-medium text-accent-900">
                  {card.label}
                </span>
                <h4 className="mt-3 font-heading text-lg font-bold leading-7 text-foreground-950">
                  {card.title}
                </h4>
                <p className="mt-3 flex-1 font-body text-[13px] leading-6 text-foreground-700">
                  {card.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 font-label text-xs text-secondary-600">
                  <span>{card.author}</span>
                  <span>{card.readTime} · {card.views} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}